import { useState } from "react";
import { API_URL } from "../constants";
import { useHistory } from "react-router-dom";
import axios from 'axios'; // Import Axios

export default function MotorDetailsFormNom({
  motor,
  setMotor,
  setEditMode,
  token
}) {
  const [newName, setNewName] = useState(motor.nom_moteur);
  const navigate = useHistory();

  const showMessagePopup = (message) => {
    alert(message);
  };

  const handleNameChange = (event) => {
    setNewName(event.target.value);
  };

  const handleSaveChangesNom = async () => {
    try {
      const response = await axios.post(`${API_URL}/moteur/nommoteur`, {
        id_moteur: motor._id,
        nom_moteur: newName,
      }, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      if (response.status === 401) {
        showMessagePopup(
          "ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer."
        );
        localStorage.clear(); 
        navigate.push("/login");
        return;
      }

      const json = response.data;
      setMotor(json);
      setNewName(newName);
      localStorage.setItem("motor", JSON.stringify(json));
      setEditMode(false);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleInputChange = (event) => {
    event.stopPropagation();
  };

  const handleModifyButtonClick = (event) => {
    event.stopPropagation();
  };

  return (
    <div>
      <input
        className="text-2xl border-4 border-orangeButton w-full rounded-xl p-4 text-center text-black mt-4 mr-2 ml-2 mb-4"
        type="text"
        value={newName}
        onChange={handleNameChange}
        onClick={handleInputChange}
      />
      <button
        className="bg-loginBordure hover:bg-blue-500 text-white text-xl rounded-2xl px-11 py-2 ml-2 cursor-pointer mb-4 w-full sm:w-[40%]"
        onClick={(event) => {
          handleSaveChangesNom();
          handleModifyButtonClick(event);
        }}
      >
        Modifier
      </button>
    </div>
  );
}
